import { countries } from 'countries-list';

export function getCurrencyFromISOCountry(countryISO?: string): string {
  if (!countryISO) return 'eur';
  return countries[countryISO].currency[0];
}
